import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { TooltipContent, TooltipTrigger } from './Tooltip.styles';
// We are not using @radix-ui/react-tooltip here, as it is not anchored to the cursor
export const Tooltip = ({ children, content, isVisible = true, offset = 16 })=>{
    const contentRef = useRef(null);
    const isFocusEnabled = useRef(true);
    const positionTooltip = (x, y)=>{
        const element = contentRef.current;
        if (element) {
            const { innerHeight, innerWidth } = window;
            const { clientHeight, clientWidth, style } = element;
            // always keep right of cursor, stick at right viewport border
            const offsetX = Math.min(x + offset, innerWidth - clientWidth - offset);
            // display below cursor, but switch to above cursor when hitting bottom viewport border
            const offsetY = y + clientHeight + offset > innerHeight ? y - clientHeight - offset : y + offset;
            style.left = `${offsetX}px`;
            style.top = `${offsetY}px`;
        }
    };
    const showFocusTooltip = ({ target })=>{
        if (isFocusEnabled.current) {
            const { height, left, top, width } = target.getBoundingClientRect();
            positionTooltip(left + width / 2, top + height / 2);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TooltipTrigger, {
                $isVisible: isVisible,
                onFocus: showFocusTooltip,
                onMouseEnter: ()=>{
                    isFocusEnabled.current = false;
                },
                onMouseLeave: ()=>{
                    isFocusEnabled.current = true;
                },
                onMouseMove: ({ clientX, clientY })=>positionTooltip(clientX, clientY),
                children: children
            }),
            content && /*#__PURE__*/ _jsx(TooltipContent, {
                $offset: offset,
                ref: contentRef,
                children: content
            })
        ]
    });
};

//# sourceMappingURL=Tooltip.js.map